import React from "react";
import { connect } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import { getreportcustomer, displayCurrency } from "../../../actions";
import "../../../assets/css/button.css";
import "../../../assets/css/popup.css";
import Re from "../../../assets/images/violet1.svg";
import Navbar from "../../../layouts/Navbar";
import Sidebar from "../../../layouts/Sidebar";
import Spinner from "../../../Components/loader";
import Pagination from "../../../Components/Pagination";
import CustomerFilter from "./customerFilter";
import { Link } from "react-router-dom";


const role = localStorage.getItem('userRole');
class CustomerExecutive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            all_report_customer: [],
            allData: [],
            show: false,
            target: null,
            pageNo: 0,
            filterData: [],
        };
        this.onChange = this.onChange.bind(this);
        this.getCustomerExe = this.getCustomerExe.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(getreportcustomer(0));
    }

    handleClick = (event) => {
        if (!this.state.show) {
            this.setState({
                show: true,
                target: event.target
            })
        } else {
            this.setState({
                show: false,
            })
        }
    };


    handleSubmit(filterData) {
        const { pageNo } = this.state;
        this.setState({
            filterData: filterData
        })
        this.props.dispatch(getreportcustomer(pageNo, filterData));
        this.setState({
            show: false,
        })
    }

    getCustomerExe() {
        this.setState({
            show: false,
            filterData: []
        })
        this.props.dispatch(getreportcustomer(0));
    }


    componentDidUpdate(prevProps) {
        if (prevProps.report_customer !== this.props.report_customer) {
            this.setState({
                all_report_customer: this.props.report_customer,
            });
        }
        if (prevProps.allData !== this.props.allData) {
            this.setState({ allData: this.props.allData });
        }
    }

    onChange(pageNo) {
        const { filterData } = this.state;
        this.setState({
            pageNo: pageNo
        })
        this.props.dispatch(getreportcustomer(pageNo, filterData));
    }

    render() {
        const { all_report_customer, allData, show, target } = this.state;

        let data = {
            totalElements: allData.totalElements,
            totalPages: allData.totalPages,
            offset: allData?.pageable?.offset,
            numberOfElements: allData.numberOfElements,
            num: (allData?.number) + 1
        }
        return (
            <>


                <div>
                    <Navbar />
                    <div className="dashboard-page">
                        <div className="dashboard-sidebar">
                            <Sidebar />
                        </div>
                        <div className="dashboard-main">
                            <Card className="staff-page">
                                <div className="page-head-split">
                                    <div className="head-colums">
                                        <div className="head-part-tab">
                                            <img src={Re} alt="..." className="head-imgs" />
                                            <h5>Reports</h5>
                                        </div>
                                        <div className="tab-links">
                                            <Link to={"/" + role + "/sale_executive"} >Sales Executive</Link>
                                            <Link to={"/" + role + "/sale_executive/customer_executive"} className="active">Customer</Link>
                                            <Link to={"/" + role + "/sale_executive/purchase_order"}>Purchase Order</Link>
                                            <Link to={"/" + role + "/sale_executive/oa"}>OA</Link>
                                        </div>
                                        <CustomerFilter
                                            onSubmit={this.handleSubmit}
                                            getCustomerExe={this.getCustomerExe}
                                            handleClick={this.handleClick}
                                            show={show} target={target}
                                            str={this.props.str}
                                        />
                                    </div>
                                </div>
                                <div className="table-class">
                                    <table class="table table-borderless">
                                        <thead>
                                            <tr>
                                                {/* <th scope="col">Customer ID</th> */}
                                                <th scope="col">Name</th>
                                                <th scope="col">Location (City, State)</th>
                                                <th scope="col" style={{ textAlign: "center" }}>Quotations Generated</th>
                                                <th>Confirmed Quotations</th>
                                                <th style={{ textAlign: "right" }}>Confirmed Amount</th>
                                                <th scope="col" style={{ textAlign: "right" }}>Estimation Amount</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {all_report_customer && all_report_customer.length > 0 ? (
                                                all_report_customer.map((one) => (
                                                    <tr key={one.customerId}>
                                                        {/* <td>{one.customerId}</td> */}
                                                        <td>{one.customerName}</td>
                                                        <td>{one.customerCity}, {one.customerState}</td>
                                                        <td style={{ textAlign: "center" }}>{one.totalQuotations}</td>
                                                        <td style={{ textAlign: "center" }}>{one.totalConfirmedQuotations}</td>
                                                        <td style={{ textAlign: "right" }}>{displayCurrency(one.estimationConfirmedAmount)}</td>
                                                        <td style={{ textAlign: "right" }}> {displayCurrency(one.totalAmount)}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : !this.props.loading ?
                                                <h1 className="empty-data">No Records Found</h1> :
                                                <Spinner />
                                            }
                                        </tbody>
                                    </table>
                                </div> </Card>
                            <Pagination data={data} onChange={this.onChange} />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.reportcustomer.loading,
        report_customer: state.reportcustomer.report_customer,
        page: state.reportcustomer.page,
        allData: state.reportcustomer.allData,
    };
};
export default connect(mapStateToProps)(CustomerExecutive);

